import React, { useState } from 'react';
import { Container, Typography, Box, Tabs, Tab } from '@mui/material';
import MaturityHandlingPage from './MaturityHandlingPage';
import PrematureMaturityPage from './PrematureMaturityPage';
import PreApprovalMaturityPage from './PreApprovalMaturityPage';
import MaturityDealTicket from '../components/MaturityDealTicket';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`maturity-tabpanel-${index}`}
      aria-labelledby={`maturity-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `maturity-tab-${index}`,
    'aria-controls': `maturity-tabpanel-${index}`,
  };
}

const MaturityPage = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Maturity Management
      </Typography>
      <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
        Daily maturity cashflow across Money Market, GSEC, Repo, and Buy/Sell (leg2) products.
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="maturity tabs">
          <Tab label="Daily Maturity Cashflow" {...a11yProps(0)} />
          <Tab label="Premature" {...a11yProps(1)} />
          <Tab label="Pre Approval" {...a11yProps(2)} />
          <Tab label="Maturity Deal Ticket" {...a11yProps(3)} />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <MaturityHandlingPage />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <PrematureMaturityPage />
      </TabPanel>

      <TabPanel value={tabValue} index={2}>
        <PreApprovalMaturityPage />
      </TabPanel>

      <TabPanel value={tabValue} index={3}>
        <MaturityDealTicket />
      </TabPanel>
    </Container>
  );
};

export default MaturityPage;
